/**
 * Helper functions for brand detection.
 */

/** Check if card number matches Discover BIN ranges */
export function isDiscover(cardNumber: string): boolean {
  // 6011
  if (cardNumber.startsWith("6011")) return true;

  // 622126-622925
  if (cardNumber.length >= 6) {
    const bin6 = parseInt(cardNumber.substring(0, 6), 10);
    if (bin6 >= 622126 && bin6 <= 622925) return true;
  }

  // 644-649
  if (cardNumber.length >= 3) {
    const bin3 = parseInt(cardNumber.substring(0, 3), 10);
    if (bin3 >= 644 && bin3 <= 649) return true;
  }

  // 65
  if (cardNumber.startsWith("65")) return true;

  return false;
}

/** Check if card number matches Mastercard BIN ranges */
export function isMastercard(cardNumber: string): boolean {
  // 51-55
  if (cardNumber.length >= 2) {
    const bin2 = parseInt(cardNumber.substring(0, 2), 10);
    if (bin2 >= 51 && bin2 <= 55) return true;
  }

  // 2221-2720
  if (cardNumber.length >= 4) {
    const bin4 = parseInt(cardNumber.substring(0, 4), 10);
    if (bin4 >= 2221 && bin4 <= 2720) return true;
  }

  return false;
}
